import { POSITIONS, ROLES } from '@utils/appData/appData'

interface Role {
  value: string
  label: string
}

interface Position {
  value: string
  label: string
}

interface OrgOption {
  value: string | number
  label?: string
  [key: string]: unknown
}

/**
 * Gets role information for a user
 * @param user - User object with role property
 * @returns Role object with value and label
 */
export function getRole(user: { role?: string }): Role {
  const found = ROLES.find((x) => x.value === user?.role)
  if (!found) return { value: '', label: '' }
  return {
    value: found.value,
    label: found.label,
  }
}

/**
 * Gets position information for a user
 * @param user - User object with position property
 * @returns Position object with value and label
 */
export function getPosition(user: { position?: string }): Position {
  if (!user?.position) return { value: '', label: '' }
  const found = POSITIONS.find((x) => x.value === user?.position)
  if (!found) return { value: '', label: '' }
  return {
    value: found.value,
    label: found.label,
  }
}

/**
 * Gets organization from organizations array
 * @param orgs - Array of organization options
 * @param selectedOrg - Selected organization object
 * @returns Organization option object
 */
export function getOrg(orgs: OrgOption[], selectedOrg: { id?: string | number }): OrgOption {
  const found = orgs.find((x) => x.value === selectedOrg?.id)
  if (!found) {
    return { value: '', label: '' }
  }
  return { ...found }
}

/**
 * Gets MIME type from base64 data URL
 * @param base64URL - Base64 data URL string
 * @returns MIME type string
 */
export function getMimeTypeFromBase64(base64URL: string): string {
  return base64URL.substring('data:'.length, base64URL.indexOf(';'))
}
